import { createFileRoute, useRouter } from "@tanstack/react-router"
import { z } from "zod"

import { AuthLoginPanel } from "@/components/AuthLoginPanel"
import { sanitizeRedirectTarget } from "@/lib/auth-guard"

const loginSearchSchema = z.object({
  redirect: z.preprocess(
    (value) => sanitizeRedirectTarget(value),
    z.string().optional(),
  ),
})

export const Route = createFileRoute("/_public/login")({
  validateSearch: loginSearchSchema,
  component: LoginRoute,
})

function LoginRoute() {
  const { redirect } = Route.useSearch()
  const router = useRouter()

  return (
    <AuthLoginPanel
      onAuthenticated={() => {
        void router.navigate({ href: redirect ?? "/" })
      }}
    />
  )
}
